import { mediaQuery, MOBILE_BOTTOM_NAV } from 'constants/ui';

const MOBILE_EDGE_GAP = 12;

export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  position: 'fixed',
  left: '50%',
  marginTop: 'env(safe-area-inset-top, 0px)',
  transform: 'translateX(-50%)',
  zIndex: 9999,

  // On mobile the top is occupied by the loan/app header, so dock toasts to the bottom (above the
  // floating bottom-nav + its safe-area inset) and span the width with small gutters instead of
  // stacking over the header on load.
  [mediaQuery.mobile]: {
    top: 'auto',
    left: `${MOBILE_EDGE_GAP}px`,
    right: `${MOBILE_EDGE_GAP}px`,
    bottom: `calc(${
      MOBILE_BOTTOM_NAV.GAP + MOBILE_BOTTOM_NAV.HEIGHT + MOBILE_EDGE_GAP
    }px + env(safe-area-inset-bottom, 0px))`,
    marginTop: 0,
    transform: 'none',
  },
};
